<template>
    <div class="examine">
        <div class="ccc">
            <div class="box">
                <div class="content">
                    <div class="content-box"><span style="color:#666">请假人:</span><span>{{data.leaveerName}}</span></div>
                    <div class="content-box"><span style="color:#666">提单人:</span><span>{{data.submitterName}}</span></div>
                    <div class="content-box"><span style="color:#666">事由:</span><span>{{data.leaveReason}}</span></div>
                </div>
            </div>
        </div>
        <div class="ccc">
            <div class="box">
                <div class="time">
                    <div class="content-box"><span style="width:7rem;font-size:1rem;color:#666">开始时间:</span><span>{{data.startTime}}</span></div>
                    <div class="content-box"><span style="width:7rem;font-size:1rem;color:#666">结束时间:</span><span>{{data.endTime}}</span></div>
                    <div class="content-box"><span style="width:7rem;font-size:1rem;color:#666">本次请假时长:</span><span>{{data.time}}</span></div>
                </div>
            </div>
        </div>
        <div class="ccc">
            <div class="box" style="algin-items:space-around">
                <div class="shen" :class="{'shens':isShow}">
                    <div style="width:100%;height:2rem;display:flex;justify-content:space-between;align-items:center;" v-if="show">
                        <div>是否需要上级审批</div>
                        <van-switch v-model="checked" active-color="#00B893" inactive-color="#dcdee0" style="border:0px"  size="20px" @change="change"/>
                    </div>
                     <div style="width:100%;height:2rem;display:flex;justify-content:space-between;align-items:center;" v-if="isShow">
                        <div style="display:flex;justify-content:space-between;algin-items:center;width:95%"><span>审批人</span><span>{{name}}</span></div>
                        <div class="bgc" @click="select"></div>
                    </div>
                    <div style="width:100%;height:1.5rem">备注:</div>
                    <textarea style="width:100%;height:5rem;resize:none;border:1px solid #ccc" placeholder="请输入备注..." v-model="text"></textarea>
                </div>
            </div>
        </div>
        <div class="ccc" style="margin-top:1rem;background-color:#f7f7f7">
            <div class="box" style="display:flex;justify-content:center;algin-items:center;background-color:#ccc">
                <van-button type="info" style="border-radius:0.25rem;width:100%;height:2.5rem;background:#FFA900;border:0px" @click="zhuanfa" v-if="isShow">同意并转发</van-button>
                <van-button type="info" style="border-radius:0.25rem;width:100%;height:2.5rem;background:#FFA900;border:0px" @click="success" v-else>同意</van-button>
            </div>
        </div>
        <div class="ccc" style="margin-top:1rem;background-color:#f7f7f7">
            <div class="box" style="display:flex;justify-content:center;algin-items:center;background-color:#ccc">
                <van-button type="info" style="border-radius:0.25rem;width:100%;height:2.5rem;background:#fff;border:1px solid #FFA900;color:#FFA900" @click="error" v-if="!isShow">驳回</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import {successLeave,zhuanfaLeave} from "@/api/http"
import Vue from 'vue';
import { Switch ,Button,Toast} from 'vant';

Vue.use(Switch);
Vue.use(Button);
Vue.use(Toast);
export default {
    data(){
        return{
            data:{
               leaveerName:"", 
               submitterName:"",
               leaveReason:"",
               startTime:"",
               endTime:"",
            },//审批的请假人信息
            checked:window.sessionStorage.getItem("checked")?JSON.parse(window.sessionStorage.getItem("checked")):false,
            text:"",
            currentInfo:JSON.parse(window.sessionStorage.getItem("currentInfo")),
            userInfo:JSON.parse(window.sessionStorage.getItem("userInfo")),
            show:null,
            name:"请选择",//存储审批人的名字
            nameList:null,//存储审批人的信息
            isShow:false,//判断是否根据审批显示审批人
        }
    },
    methods:{
        //计算时间
        computedTime(time){
            console.log(time)
            let h = time/1000/60/60
            console.log(h)
            if(h<24){
                return h+"小时"
            }
            if(h === 24 ){
                return 1 + "天"
            }
            if(h > 24){
                if(h%24 === 0){
                    return parseInt(h/24) + "天"
                }else{
                    return parseInt(h/24) + "天" + (h % 24) + "小时"
                }
                
            }
        },
        //格式化时间
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            let hour = time.getHours();
            let minute = time.getMinutes();
            let second = time.getSeconds();
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute
        },
        //同意
        success(){
            window.sessionStorage.removeItem("isShow")
            window.sessionStorage.removeItem("checked")
            window.sessionStorage.removeItem("date")
            let data = [{"id":this.data.id,"leaveState":11,"approvalUserId":this.currentInfo.id,"approvalRemark":this.text}]
            successLeave(data).then(res=>{
                if(res.data.code === 200){
                    Toast.success(res.data.data)
                    this.$router.push("/teacherLeave")
                }else{
                    Toast.fail(res.data.data)
                }
            })
        },
        //同意并转发
        zhuanfa(){
            zhuanfaLeave(this.data.id,this.text,this.nameList[0].id).then(res=>{
                if(res.data.code === 200){
                    Toast.success(res.data.msg)
                    this.$router.push("/teacherLeave")
                }else{
                    Toast.fail(res.data.msg)
                }
            })
            window.sessionStorage.removeItem("isShow")
            window.sessionStorage.removeItem("checked")
            window.sessionStorage.removeItem("date")
        },
        //不同意
        error(){
            window.sessionStorage.removeItem("isShow")
            window.sessionStorage.removeItem("checked")
            window.sessionStorage.removeItem("date")
            let data = [{"id":this.data.id,"leaveState":12,"approvalUserId":this.currentInfo.id,"approvalRemark":this.text}]
            successLeave(data).then(res=>{
                if(res.data.code === 200){
                    Toast.success("驳回成功")
                    this.$router.push("/teacherLeave")
                }else{
                    Toast.fail("未知错误")
                }
            })
        },
        //是否需要审批
        change(){
            console.log(this.checked)
            if(this.checked === true){
                this.isShow = true
            }else{
                this.isShow = false
            }
        },
        //选择转发审批人
        select(){
            window.sessionStorage.setItem("isShow",this.isShow)
            window.sessionStorage.setItem("checked",this.checked)
            this.$router.push({
                path:"/shenpi",
                query:{
                    type:true
                }
            })
        }
    },
    mounted(){
        if(window.sessionStorage.getItem("date")){
            this.nameList = JSON.parse(window.sessionStorage.getItem("date"))
            this.name = this.nameList[0].name
        }
        if(window.sessionStorage.getItem("item")){
            this.data = JSON.parse(window.sessionStorage.getItem("item"))
            
            this.data.startTime = new Date(this.data.startTime)
            this.data.endTime = new Date(this.data.endTime)
            
            let time = this.data.endTime.getTime() - this.data.startTime.getTime()
            console.log(time)
            console.log(this.computedTime(time))
            time = this.computedTime(time)
            console.log(time)
            this.data["time"] = time
            this.data.startTime = this.timeFormat(this.data.startTime)
            this.data.endTime = this.timeFormat(this.data.endTime)
        }
        if(window.sessionStorage.getItem("isShow")){
            this.isShow = window.sessionStorage.getItem("isShow")
        }
        console.log(this.checked)
        for(let i = 0; i < this.userInfo.schools[0].roles.length;i++){
            if(this.userInfo.schools[0].roles[i].id === 6){
                this.show = true
                break;
            }else{
                this.show = false
            }
        }
        
    }
}
</script>

<style scoped>
    .examine{
        width: 100%;
        background-color: #f7f7f7;
        height: 100%;
    }
    .ccc{
        width: 100%;
        background-color: #fff;
    }
    .box{
        width: calc(100% - 2rem);
        margin: 0 auto;
    }
    .bar{
        width: 100%;
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        box-sizing: border-box;
        border-bottom: 1px solid #fff;
    }
    .content{
        width: 100%;
        height: 8rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
    }
    .content-box{
        width: 100%;
        height: 2rem;
        display: flex;
        align-items: center;
    }
    .content-box span:nth-child(1){
        display: inline-block;
        width: 4rem;
    }
    .time{
        width: 100%;
        margin-top: 1rem;
        height: 8rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
    }
    .shen{
        margin-top: 1rem;
        height: 12rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
    }
    .shens{
        height: 14rem;
    }
    .bgc{
        width: 0.44rem;
        height: 0.75rem;
        background: url("../img/kuohao.png");
        background-size:100% 100%;
    }
</style>